import { render } from "./PrivacyModal.vue?vue&type=template&id=1f3ce95a&scoped=true"
import script from "./PrivacyModal.vue?vue&type=script&lang=js"
export * from "./PrivacyModal.vue?vue&type=script&lang=js"

import "./PrivacyModal.vue?vue&type=style&index=0&id=1f3ce95a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3ce95a"]])

export default __exports__